import axios from "axios";

var monitor_api = {
  async post_monitor(monitor) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/monitor`;
    const response = await axios.post(request_url, monitor);
    return response;
  },

  async get_monitor(monitor_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/monitor/config/${monitor_id}`;
    const response = await axios.get(request_url);
    return response;
  },

  async disable_monitor(monitor_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/monitor/config/${monitor_id}`;
    const response = await axios.delete(request_url);
    return response;
  },

  async get_monitor_history(monitor_id, page_token, sort) {
    const limit = 5;
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/monitor/history/${monitor_id}?limit=${limit}&starting_after=${page_token}&sort=${sort}`;
    const response = await axios.get(request_url);
    return response;
  },

  async get_monitor_listing_page(
    account_id,
    page_token,
    active_only,
    sort,
    api_filters,
    limit = 6
  ) {
    let request_url = "";
    if (account_id) {
      request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/monitor?limit=${limit}&starting_after=${page_token}&active_only=${active_only}&sort=${sort}${api_filters}`;
    } else {
      request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/monitor?limit=${limit}&starting_after=${page_token}&active_only=${active_only}&sort=${sort}${api_filters}`;
    }
    const response = await axios.get(request_url);
    return response;
  },
};

export default monitor_api;
